export default __webpack_public_path__ + "static/media/front_page_2.269dad25.jpg";